module.exports = __webpack_public_path__ + "img/圆6排6列.fae31a70.png";